import { GetComparator, KeyedObject } from 'types';
import { User } from 'types/user';

export const descendingComparator = (a: KeyedObject, b: KeyedObject, orderBy: string) =>
  String(b[orderBy])?.localeCompare(String(a[orderBy]), undefined, { numeric: true });

export const informedConsentComparator = (a: KeyedObject, b: KeyedObject, orderBy: string) => {
  const val1 = new Date(b[orderBy]).getTime();
  const val2 = new Date(a[orderBy]).getTime();
  return val1 - val2;
};

export const getComparator: GetComparator = (order, orderBy, intl?) => {
  if (orderBy === 'icVerification') {
    return order === 'desc' ? (a, b) => informedConsentComparator(a, b, orderBy) : (a, b) => -informedConsentComparator(a, b, orderBy);
  }
  if (orderBy === 'status') {
    return order === 'desc' ? (a, b) => descendingComparatorStatus(a, b) : (a, b) => -descendingComparatorStatus(a, b);
  }
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparatorStatus = (a: any, b: any) => {
  const statusA = checkTableStatus(a);
  const statusB = checkTableStatus(b);
  return statusB?.localeCompare(statusA);
};

// TODO - French sorting
export const checkTableStatus = (user: User) => {
  if (user?.hidden) {
    return 'Draft';
  }
  if (user?.disabled) {
    return 'Disabled';
  }
  if (user?.inactive) {
    return 'Inactive';
  }
  if (user?.emailVerified) {
    return 'Active';
  }

  return 'Pending';
};

export const stableSort = (array: any[], comparator: (a: any, b: any) => number) => {
  const stabilizedThis = array.map((el: any, index: number) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0] as any, b[0] as any);
    if (order !== 0) return order;
    return (a[1] as number) - (b[1] as number);
  });

  return stabilizedThis.map((el) => el[0]);
};

export const convertBody = (richTextData: string) => {
  try {
    const data = JSON.parse(richTextData);
    return data?.blocks?.map((it) => it.text).join('<br />');
  } catch (e) {
    return richTextData;
  }
};
